import { DropdownValue, GeoCoordinates } from '../@types/types'

export const COUNTRY_CODE_GERMANY = 276

export function isGermanCountryCode(countryCode: number | DropdownValue): boolean {
  return countryCode !== null && String(countryCode) === String(COUNTRY_CODE_GERMANY)
}

export function hasUsableGeoCoordinates(coordinates: GeoCoordinates | undefined): coordinates is GeoCoordinates {
  return !!(
    coordinates &&
    Number.isFinite(coordinates.latitude) &&
    Number.isFinite(coordinates.longitude) &&
    (coordinates.latitude !== 0 || coordinates.longitude !== 0)
  )
}
